/**
 * @flow
 */
import React from "react"
import styled from "styled-components"

type Props = {
  step: number,
}

const Container = styled.div`
  display: grid;
  align-items: center;
  margin-bottom: 2rem;
  grid-template-columns: minmax(30px, 50px) 1fr minmax(30px, 50px) 1fr minmax(
      30px,
      50px
    );
  width: 100%;
  max-width: 800px;
  margin-left: auto;
  margin-right: auto;

  .step {
    display: flex;
    align-items: center;
    justify-content: center;
    color: white;
    width: 100%;
    aspect-ratio: 1 / 1;
    border: 3px solid var(--havelock-blue);
    border-radius: 50%;
    font-size: clamp(0.8rem, 2.5vw, 1.2rem);

    &.one {
      background-color: var(--havelock-blue);
    }
    &.two {
      background-color: ${props =>
        props.step > 0 ? `var(--havelock-blue)` : `transparent`};
      color: ${props => (props.step > 0 ? `white` : `var(--havelock-blue)`)};
    }
    &.three {
      background-color: ${props =>
        props.step > 1 ? `var(--havelock-blue)` : `transparent`};
      color: ${props => (props.step > 1 ? `white` : `var(--havelock-blue)`)};
    }
  }

  .bar {
    height: 3px;
    background-color: var(--havelock-blue);
    width: 100%;
  }
`

const StepIndicator = ({ step }: Props) => {
  return (
    <Container step={step}>
      <div className="step one font-black">1</div>
      <div className="bar"></div>
      <div className="step two font-black">2</div>
      <div className="bar"></div>
      <div className="step three font-black">3</div>
    </Container>
  )
}

export default StepIndicator
